import  React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';

// bootstrap 
import Container from 'react-bootstrap/Container';
import { Col, Row } from 'react-bootstrap';


import { ServiceDetailWrapper } from './Servicedetail.style';
import Layout from '../components/layout/Layout';


function ServiceDetail() {
  const { id } = useParams();
  const [ data, setData ] = useState([]);
  

  let base64 = require("base-64");

  const username = `${process.env.REACT_APP_API_USERNAME}`;
  const password = `${process.env.REACT_APP_API_PASSWORD}`;
  
  useEffect(() => {
    axios.get(`https://vinod-soba.co.uk/wp-json/wp/v2/service/${id}`, {
      
        headers: {
            Authorization: "Basic " + base64.encode(username + ':' + password),
        }
    
    })
    .then((response) => setData({
      data: response.data,
      title: response.data.title.rendered,
      headerTitle: response.data.acf.header_title,
      heroImages: response.data.acf.hero_image_background,
      postImages: response.data.acf.post_images,
      servicesContent: response.data.acf.services_content,
    })
    )
    
  }, [])
 
    console.log(data);
  return (
      <Layout>
      <ServiceDetailWrapper>
      <div className='header-hero-container' style={data.heroImages ? { backgroundImage: `url(${data.heroImages})`}: {backgroundColor: 'var(--bg-header-light)'}}>
          <div
          style={data.heroImages ? { color: 'var(--text-primary-dark)'} : {color: 'var(--text-primary-light)'}} 
          className="header-title" 
          dangerouslySetInnerHTML={{__html: data.title }} 
          /> 
      </div>
      <section className='port-col-wrap'>
      <Container>
          <h2><div dangerouslySetInnerHTML={{__html: data.headerTitle}} /></h2>
          <Row>           
            <Col md={6} className="pt-4 pb-4">
                  <img src={data.postImages} />
            </Col>
          <Col md={6}><div dangerouslySetInnerHTML={{__html: data.servicesContent }} /></Col>
          </Row>
        </Container>
      </section>
    </ServiceDetailWrapper>
    </Layout>      
  )
}

export default ServiceDetail;

